import "./ProductFeatureUnderTheHood.css";

interface UnderTheHoodContent {
  paragraphs: string[];
  imageSrc?: string;
  imageAlt?: string;
}

interface ProductFeatureUnderTheHoodProps {
  title: string;
  heading: string;
  body: string;
  content: UnderTheHoodContent;
}

export const ProductFeatureUnderTheHood: React.FC<ProductFeatureUnderTheHoodProps> = ({ content }) => {
  return (
    <div className="product-feature-under-the-hood">
      <div className="under-the-hood-content">
        <div className="under-the-hood-text">
          <div className="under-the-hood-header">
            <h3 className="under-the-hood-title">Under the Hood</h3>
            <img src="/svg/x.svg" alt="" className="under-the-hood-x" draggable={false} />
          </div>
          {content.paragraphs.map((paragraph, index) => (
            <p key={index} className="under-the-hood-paragraph">
              {paragraph}
            </p>
          ))}
        </div>

        {content.imageSrc && (
          <div className="under-the-hood-image">
            <img src={content.imageSrc} alt={content.imageAlt || "Feature detail"} draggable={false} />
          </div>
        )}
      </div>
    </div>
  );
};
